import { c as _c } from "react/compiler-runtime";
import { MiniChips } from "@website/ui/mini-chips";
import { RadioGroup } from "@website/ui/radio-group";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { RadioTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { useEffect, useId, useState } from "react";
interface RadioProperties extends RadioTypes {
  name: string;
  showTitle?: boolean;
}
export const RadioFilter = t0 => {
  const $ = _c(26);
  const {
    name,
    title,
    description,
    defaultValue,
    items,
    isNew,
    showTitle: t1
  } = t0;
  const showTitle = t1 === undefined ? true : t1;
  const router = useRouter();
  const radioGroupName = `${name}-${useId()}`;
  const queryValue = router.query[name];
  const routerValue = String((Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? defaultValue ?? "");
  const [value, setValue] = useState(routerValue);
  let t2;
  let t3;
  if ($[0] !== routerValue) {
    t2 = () => {
      setValue(routerValue);
    };
    t3 = [routerValue];
    $[0] = routerValue;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== defaultValue || $[4] !== name || $[5] !== router) {
    t4 = function onChange(t5) {
      const {
        target: t6
      } = t5;
      const {
        value: nextValue
      } = t6;
      setValue(nextValue);
      return router.replace({
        query: deepOmit({
          ...router.query,
          [name]: nextValue === defaultValue ? undefined : nextValue
        }, isFilled)
      }, undefined, {
        shallow: true,
        scroll: false
      });
    };
    $[3] = defaultValue;
    $[4] = name;
    $[5] = router;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onChange = t4;
  let t5;
  if ($[7] !== showTitle || $[8] !== title) {
    t5 = showTitle && <div className={styles["filter-header"]} id="has-availability">{title}</div>;
    $[7] = showTitle;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== description) {
    t6 = description && <span className={styles["has-availability"]}>{description}</span>;
    $[10] = description;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isNew) {
    t7 = isNew && <MiniChips color="primary" text={"\u062C\u062F\u06CC\u062F"} variant="round-contained" />;
    $[12] = isNew;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="grid grid-cols-3 items-center justify-start gap-2 whitespace-nowrap">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== items || $[19] !== onChange || $[20] !== radioGroupName || $[21] !== value) {
    t9 = <RadioGroup className="w-full flex-col !items-start" color="secondary" itemClassName={`${process.env.NEXT_PUBLIC_BASE_PATHNAME?.includes("\u0631\u0632\u0631\u0648-\u0647\u062A\u0644") || process.env.NEXT_PUBLIC_BASE_PATHNAME?.includes("villa") ? "!text-body-2" : "text-subtitle-2"}`} items={items} radioClassName="!w-full !flex !justify-between" name={radioGroupName} value={value} onChange={onChange} />;
    $[18] = items;
    $[19] = onChange;
    $[20] = radioGroupName;
    $[21] = value;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className={styles["radio-filter-container"]}>{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};